import React from 'react';
import { Route } from 'react-router-dom';
import { GroupsEnum } from '@/types/users';
import { RoleRoute } from './RouteGuards';

const ManualPage = React.lazy(() => import('@/pages/Manual/ManualPage'));
const AcceptUserPage = React.lazy(() => import('@/pages/Manual/AcceptUserPage'));
const ManualPhotoPage = React.lazy(() => import('@/pages/Manual/ManualPhotoPage'));
const ManualMapPage = React.lazy(() => import('@/pages/Manual/ManualMapPage'));

const manualRoute = (path: string, element: React.ReactNode) => (
  <Route
    key={path}
    path={path}
    element={<RoleRoute groups={[GroupsEnum.MANUAL_REG]}>{element}</RoleRoute>}
  />
);

const routeDefinitions = [
  { path: 'manual', element: <ManualPage /> },
  { path: 'manual/accept/:code', element: <AcceptUserPage /> },
  { path: 'manual/photo/:userId', element: <ManualPhotoPage /> },
  { path: 'manual/maps/:code/:userId/:imageId', element: <ManualMapPage /> },
];

export const manualRoutePaths = routeDefinitions.map(({ path }) => path);
export const manualRoutes = routeDefinitions.map(({ path, element }) => manualRoute(path, element));
